export default __webpack_public_path__ + "static/media/mas_salagros.f34d660e.jpg";